// popup.service.ts
import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class PopupService {
  private popupRef: Window | null = null;

  constructor(private localStorage: LocalStorageService) {}
  abrirVentana(url: string, titulo: string, ancho = 800, alto = 600) {
    const left = (window.screen.width / 2) - (ancho / 2);
    const top = (window.screen.height / 2) - (alto / 2);
    this.popupRef = window.open(
      url,
      titulo,
      `width=${ancho},height=${alto},top=${top},left=${left}`
    );

    if (this.popupRef) {
      this.popupRef.focus();
    }
    
    const check = setInterval(() => {
        if (!this.popupRef || this.popupRef.closed) {
          clearInterval(check);
          this.popupRef = null;
          this.localStorage.deleteCookie('MRHSession');
          this.cerrarSesion(url);
        }
      }, 100);
  }

  verCookies() {
    const cookies = document.cookie.split(';');
    const lista: { [key: string]: string } = {};
  
    cookies.forEach(cookie => {
      const [nombre, valor] = cookie.split('=');
      if (nombre && valor) {
        lista[nombre.trim()] = decodeURIComponent(valor);
      }
    });
  
    alert(JSON.stringify(lista, null, 2));
  }
  
  
  async cerrarSesion(url: string) {
    const urlBase = new URL(url).origin;
    try {
      await fetch( urlBase + '/vdesk/hangup.php3', { credentials: 'include',mode: 'no-cors' });
    } catch(err) {
      try {
        fetch(urlBase,{ mode: 'no-cors' });
      } catch (err) {
        console.error(err);
      }
    }
  }
  cerrarVentana(url: string) {

    if (this.popupRef && !this.popupRef.closed) {
      this.localStorage.deleteCookie('MRHSession');
      this.cerrarSesion(url);
      
      this.popupRef.close();
      this.popupRef = null;
    }
  }

  estaAbierta(): boolean {
    return !!(this.popupRef && !this.popupRef.closed);
  }

  obtenerReferencia(): Window | null {
    return this.popupRef;
  }
}
